import { useMemo } from 'react';

export type UseAssetLibraryItemGesturesDesktopParams = {
    onOpenItem: () => void;
    onTap: () => void;
};

/**
 * Desktop: single click selects / range behavior via parent `onTap`; double-click opens.
 */
export const useAssetLibraryItemGesturesDesktop = ({
    onOpenItem,
    onTap,
}: UseAssetLibraryItemGesturesDesktopParams): {
    onClick: () => void;
    onDoubleClick: () => void;
} =>
    useMemo(
        () => ({
            onClick: onTap,
            onDoubleClick: onOpenItem,
        }),
        [onTap, onOpenItem],
    );
